<template>
  <div class="w-100 order-list-table">
    <div>
      <b-row>
        <b-col cols="9">
          <p class="mt-4 text-dark" style="font-weight: 500">
            Tổng số:
            {{ convertPrice(mainList.total) }}
          </p>
        </b-col>
        <b-col cols="3">
          <div>
            <b-pagination-nav
              pills
              size="sm"
              v-show="mainList.pages >= 2"
              :number-of-pages="mainList.pages"
              :link-gen="linkGen"
              align="right"
              v-model="currentPage"
              use-router
              @change="fetchMainData()"
              class="mt-3"
              style="border-radius: 5px"
            ></b-pagination-nav>
          </div>
        </b-col>
      </b-row>

      <table class="table table-bordered-list table-hover col-md-12">
        <thead>
          <tr>
            <th class="text-center header-table-color">
              <b-form-checkbox
                v-model="checkAllOrders"
                size="lg"
                @change="getOrderSelected('all')"
              ></b-form-checkbox>
            </th>
            <th class="text-center header-table-color">Mã HĐ</th>
            <th class="text-center header-table-color" style="width: 15%">
              Khách hàng
            </th>
            <th class="text-center header-table-color" style="width: 20%">
              Sản phẩm
            </th>
            <th class="text-center header-table-color">Giá</th>
            <th class="text-center header-table-color">SL</th>
            <th class="text-center">Tổng tiền</th>
            <!-- <th class="text-center header-table-color">
              <i
                v-b-tooltip.hover
                title="Thanh toán"
                class="fa fa-money-check-alt icon-color"
              ></i>
            </th>
            <th class="text-center header-table-color" style="width: 15%">
              Ghi chú
            </th> -->
            <th
              class="text-center header-table-color"
              style="white-space: nowrap"
            >
              Giữ hàng / Phân bổ xe
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(contract, i) in mainList.dataset">
            <tr
              :key="i"
              @mouseover="hoverRow"
              @mouseleave="outRow"
              :data="`row_${contract.id}`"
            >
              <td
                colspan="8"
                style="padding: 5px !important; border-bottom: none !important"
              >
                <div class="d-flex" style="font-size: 0.87rem">
                  <!-- <span class="mr-4" v-if="contract.orderType">
                    <div class="text-center">
                      <i
                        v-if="order.orderType === ENUM.TYPE_ORDER.SHOP"
                        class="fas fa-store icon-color text-warning"
                        v-b-tooltip.hover.bottom
                        title="Mua tại quầy"
                      ></i>
                      <i
                        v-else-if="order.orderType === ENUM.TYPE_ORDER.PREORDER"
                        class="fas fa-shopping-basket icon-color text-danger"
                        v-b-tooltip.hover.bottom
                        title="Đặt trước"
                      ></i>
                      <i
                        v-else-if="order.orderType === ENUM.TYPE_ORDER.SHIPPING"
                        class="fas fa-truck icon-color text-success"
                        v-b-tooltip.hover.bottom
                        title="Tự vận chuyển"
                      ></i>
                      <i
                        v-else-if="
                          order.orderType === ENUM.TYPE_ORDER.EX_SHIPPING
                        "
                        class="fas fa-box icon-color text-primary"
                        v-b-tooltip.hover.bottom
                        title="Hãng vận chuyển (Ahamove, Nhất tín ...)"
                      ></i>
                      <i
                        v-else-if="order.orderType === ENUM.TYPE_ORDER.WEBSITE"
                        class="fas fa-globe-asia text-dark"
                        v-b-tooltip.hover.bottom
                        title="Website"
                      ></i>
                    </div>
                  </span> -->
                  <span class="mr-4">
                    Ngày tạo:
                    <span class="text-primary">
                      {{
                        formatDate(contract.createdAt, 'DD/MM/YYYY HH:mm')
                      }}</span
                    >
                  </span>
                  <span
                    class="mr-4"
                    v-if="contract.createdAt !== contract.updatedAt"
                  >
                    Cập nhật:
                    <span class="text-primary">
                      {{
                        formatDate(contract.updatedAt, 'DD/MM/YYYY HH:mm')
                      }}</span
                    >
                  </span>
                  <!-- Cảnh báo HĐ chưa nhập mã tham chiếu — ngang hàng Ngày tạo, chữ đỏ -->
                  <span
                    class="mr-4 ctr-missing-code-text d-inline-flex align-items-center"
                    v-if="hasMissingPaymentCode(contract)"
                  >
                    <i class="fas fa-exclamation-triangle mr-1"></i>Thiếu mã
                    tham chiếu
                  </span>
                  <!-- <span v-if="order.orderSourceName" class="mr-4">
                    <span class="mr-1">Nguồn:</span>
                    <span>{{ order.orderSourceName }}</span>
                  </span>
                  <span class="mr-4" v-if="order.partnerPaymentStatus">
                    <span class="mr-1">Thanh toán:</span>
                    <span v-bind:class="bindClassNamePayment(order)">
                      {{ order.partnerPaymentStatusName }}</span
                    >
                  </span> -->
                </div>
                <div class="d-flex" style="font-size: 0.87rem">
                  <span class="mr-4" v-if="contract.createdByName">
                    <span class="mr-1">NVCR:</span>
                    <span>
                      {{ contract.createdByName }}
                      <small v-if="contract.departmentName"
                        >({{ contract.departmentName }})</small
                      >
                    </span>
                  </span>
                  <span class="mr-4" v-if="contract.userCreated">
                    <span class="mr-1">Người Tạo:</span>
                    <span>
                      {{ contract.userCreated?.fullName }}
                    </span>
                  </span>
                </div>
              </td>
              <td
                colspan="1"
                style="border-bottom: none !important"
                class="text-center"
              >
                <i
                  class="fa fa-download text-primary cursor-pointer"
                  aria-hidden="true"
                  @click="openFileModal(contract)"
                ></i>
              </td>
            </tr>
            <template v-for="(contractDetail, j) in contract.contractDetail">
              <tr
                :key="i + j + contractDetail.id"
                @mouseover="hoverRow"
                @mouseleave="outRow"
                :data="`row_${contract.id}`"
              >
                <td
                  :rowspan="contract.contractDetail.length"
                  v-if="j === 0 || contract.show ? true : false"
                  class="tdCenter"
                >
                  <b-form-checkbox
                    size="lg"
                    v-model="contract.selected"
                    @change="getOrderSelected('one')"
                    class="text-center ml-1"
                  />
                </td>
                <td
                  :rowspan="contract.contractDetail.length"
                  v-if="j === 0 || contract.show ? true : false"
                  class="tdCenter text-center"
                >
                  <div
                    class="orderCode text-primary font-weight-bold"
                    @click="editItem(contract)"
                  >
                    {{ contract.contractNumber }}
                  </div>

                  <!-- FE-005 — badge trạng thái HĐ (state machine 9 bước) -->
                  <div v-if="contract.status" class="mt-1">
                    <b-badge :variant="contractStatusVariant(contract.status)">
                      {{ contractStatusLabel(contract.status) }}
                    </b-badge>
                  </div>

                  <b v-if="contract.store" class="mt-2 d-block">
                    {{ contract.store?.name }}
                  </b>

                  <!-- Link Đề Nghị nguồn (nếu HĐ tạo từ Đề Nghị) -->
                  <div
                    v-if="contract.contractRequestId"
                    class="mt-2"
                    style="font-size: 0.85rem"
                  >
                    <i class="fas fa-link text-muted mr-1"></i>
                    <a
                      href="javascript:void(0)"
                      class="text-primary"
                      style="text-decoration: underline"
                      @click="goToContractRequest(contract.contractRequestId)"
                    >
                      {{
                        (contract.contractRequest &&
                          contract.contractRequest.code) ||
                        'Đề nghị nguồn'
                      }}
                      <i
                        class="fas fa-external-link-alt ml-1"
                        style="font-size: 0.7rem"
                      ></i>
                    </a>
                  </div>

                  <div class="mt-2" v-if="contract.bill">
                    <span class="text-warning"
                      ><i class="fas fa-receipt" title="Hóa đơn từ đơn hàng"></i
                    ></span>
                    <div
                      class="orderCode text-center"
                      @click="linkToBill(contract?.bill?.billNumber)"
                      style="cursor: pointer"
                    >
                      <span
                        style="color: darkgoldenrod"
                        v-text="contract?.bill?.billNumber"
                      ></span>
                    </div>
                  </div>
                </td>
                <td
                  :rowspan="contract.contractDetail.length"
                  v-if="j === 0 || contract.show ? true : false"
                  class="tdCenter"
                >
                  <small
                    v-if="
                      [
                        ENUM.CUSTOMER_TYPE.BUSSINESS,
                        ENUM.CUSTOMER_TYPE.CUSTOMER,
                      ].includes(contract.customerType)
                    "
                    style="color: #fd9d9d"
                    >({{
                      ENUM.CUSTOMER_TYPE_NAME[contract.customerType]
                    }})</small
                  >
                  <small v-else style="color: #a4a4a5">
                    ({{ ENUM.CUSTOMER_TYPE_NAME[contract.customerType] }})
                  </small>
                  <p
                    class="orderCode mb-0"
                    @click="editUser(contract)"
                    style="font-weight: 550"
                  >
                    {{ contract.customerName }}
                  </p>
                  <p class="orderCode mb-0" @click="editUser(contract)">
                    {{ contract.customerPhone }}
                  </p>
                  <div
                    v-if="
                      contract.customerAddress &&
                      contract.customerAddress.trim().length > 0
                    "
                  >
                    <b>ĐC:</b>
                    {{ contract.customerAddress }}
                  </div>
                </td>

                <td class="align-middle">
                  <p class="m-0">
                    {{ contractDetail.productName }}
                    <MerchantLabel :merchantId="contractDetail.merchantId" />
                  </p>

                  <p v-if="contractDetail.productChassis">
                    <i class="text-primary" style="font-size: 12px"
                      >SK: {{ contractDetail.productChassis.chassisNumber }}</i
                    ><br />
                    <i class="text-primary" style="font-size: 12px"
                      >SM: {{ contractDetail.productChassis.engineNumber }}</i
                    >
                  </p>

                  <p v-if="contractDetail.productSerial">
                    <i class="text-primary" style="font-size: 12px"
                      >SERI: {{ contractDetail.productSerial.serialNumber }}</i
                    ><br />
                  </p>
                </td>

                <td class="text-right align-middle">
                  {{ convertPrice(contractDetail.productPrice) }}
                  <p
                    v-b-tooltip.hover.bottom
                    title="Chiết khấu sản phẩm"
                    v-if="contractDetail.discountAmount"
                  >
                    <i
                      class="fa fa-arrow-down icon-color"
                      style="font-size: 12px; text-align: center"
                    ></i
                    >:
                    <b class="text-warning">
                      {{ convertPrice(contractDetail.discountAmount) }}
                      <template
                        v-if="
                          contractDetail.discountType ===
                          ENUM.DISCOUNT_AMOUNT.PERCENT
                        "
                        >%</template
                      >
                      <template v-else>đ</template>
                    </b>
                  </p>
                </td>

                <td class="text-center align-middle">
                  {{ contractDetail.quantity }}
                </td>

                <td
                  :rowspan="contract.contractDetail.length"
                  v-if="j === 0 || contract.show ? true : false"
                  class="text-right align-middle"
                >
                  <p v-show="contract.totalDiscountAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Chiết khấu"
                      class="fa fa-arrow-down icon-color"
                    ></i>
                    :
                    {{
                      convertPrice(
                        calculateDiscountAmountV2(
                          contract.totalDiscountAmount,
                          contract.discountType,
                          contract.totalAmountBeforeDiscount,
                        ),
                      )
                    }}
                    <!-- : {{ convertPrice(contract.totalDiscountAmount) }} -->
                    <!-- <span
                      v-if="order.discountType === ENUM.DISCOUNT_AMOUNT.PERCENT"
                    >
                      %
                    </span>
                    <span v-else> đ </span> -->
                  </p>
                  <b style="color: #2e7d32">
                    {{ convertPrice(contract.totalAmountAfterDiscount) }}</b
                  ><br />

                  <template
                    v-if="contract.payments && contract.payments.length"
                  >
                    <hr style="border: none; border-top: 1px dashed #bbb" />
                    <i
                      v-b-tooltip.hover
                      :title="'Tổng đã thu'"
                      class="icon-color mr-1 fas fa-money-bill-alt"
                      :class="
                        contract.totalRemainingAmount > 0
                          ? 'text-dark'
                          : 'text-success'
                      "
                    ></i
                    >:
                    <span
                      style="font-weight: 700"
                      :class="{
                        'text-success': !(contract.totalRemainingAmount > 0),
                      }"
                      >{{ convertPrice(contract?.totalPaid || 0) }}</span
                    >
                    <p
                      class="d-block mt-1 mb-0"
                      style="color: #e65b5b; font-weight: 700"
                      v-if="contract?.totalRemainingAmount > 0"
                    >
                      Còn thiếu:
                      <span class="d-block">
                        {{
                          convertPrice(contract?.totalRemainingAmount || 0)
                        }}</span
                      >
                    </p>
                  </template>
                  <!-- <p v-show="order.customerShipFee > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Phí ship"
                      class="fas fa-shipping-fast icon-color"
                    ></i>
                    : {{ convertPrice(order.customerShipFee) }}
                  </p>
                  <p v-show="order.shipFee > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Phí trả hãng vận chuyển"
                      class="fas fa-hand-holding-usd icon-color"
                    ></i>
                    : {{ convertPrice(order.shipFee) }}
                  </p>
                  <p v-show="order.conversionFee > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Phí chuyển đổi"
                      class="fa-solid fa-money-bill-transfer icon-color"
                    ></i>
                    : {{ convertPrice(order.conversionFee) }}
                  </p>
                  <p v-show="order.discountAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Chiết khấu"
                      class="fa fa-arrow-down icon-color"
                    ></i>
                    : {{ convertPrice(order.discountAmount) }}
                    <span v-if="order.discountType === 2"> % </span>
                  </p>
                  <b style="color: #2e7d32">
                    {{
                      convertPrice(order.totalAmount + order.conversionFee)
                    }}</b
                  > -->
                </td>
                <!-- <td
                  :rowspan="order.contractDetail.length"
                  v-if="j === 0 || order.show ? true : false"
                  class="text-right align-middle"
                >
                  <p v-show="order.depositAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Đặt cọc"
                      class="fa fa-money-check-alt icon-color"
                    ></i>
                    : {{ convertPrice(order.depositAmount) }}
                  </p>
                  <p v-show="order.subtractPointAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Tiêu điểm"
                      class="fas fa-adjust icon-color"
                    ></i>
                    : {{ convertPrice(order.subtractPointAmount) }}
                  </p>
                  <p v-show="order.transferAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Đã chuyển khoản"
                      class="fa fa-university icon-color"
                    ></i>
                    : {{ convertPrice(order.transferAmount) }}
                  </p>
                  <p v-show="order.creditAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Tiền quẹt thẻ"
                      class="fa fa-credit-card icon-color"
                    ></i>
                    : {{ convertPrice(order.creditAmount) }}
                  </p>
                  <p v-show="order.installedMoneyAmount > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Trả góp"
                      class="fa fa-cube icon-color"
                    ></i>
                    : {{ convertPrice(order.installedMoneyAmount) }}
                  </p>
                  <p v-show="order.conversionFee > 0" class="border-0">
                    <i
                      v-b-tooltip.hover
                      title="Thanh toán phí chuyển đổi"
                      class="fa-solid fa-money-bill-transfer icon-color"
                    ></i>
                    : {{ convertPrice(order.conversionFee) }}
                  </p>
                  <span
                    v-b-tooltip.hover
                    v-show="order.totalAmountCustomerPay < 0"
                    title="Tiền thừa"
                    style="font-weight: 500"
                    class="border-0 text-success"
                    >{{ convertPrice(order.changeMoney) }}</span
                  >
                  <span
                    v-b-tooltip.hover
                    v-show="order.totalAmountCustomerPay > 0"
                    title="Phải thu khách"
                    style="font-weight: 500"
                    class="border-0 text-warning"
                    >{{ convertPrice(order.totalAmountCustomerPay) }}</span
                  >
                </td> -->

                <!-- <td
                  :rowspan="order.contractDetail.length"
                  v-if="j === 0 || order.show ? true : false"
                  class="wrapword"
                >
                  <span
                    v-if="order.codeShip && order.codeShip.trim().length > 0"
                    class="d-block mb-1"
                  >
                    <b>Mã vận đơn:</b> {{ order.codeShip }}
                  </span>
                  <span
                    v-if="
                      order.couponCode && order.couponCode.trim().length > 0
                    "
                    class="d-block"
                  >
                    <b>Mã coupon:</b> {{ order.couponCode }}
                  </span>
                  <p
                    v-if="order.codeShip && order.codeShip.trim().length > 0"
                    class="dashed"
                  ></p>

                  <p
                    @click="handleShowNoteModel(order)"
                    style="cursor: pointer"
                    class="float-right"
                  >
                    <i class="fas fa-edit"></i>
                  </p>
                  <p v-if="order.customerNote" class="pre-line">
                    {{ order.customerNote }}
                  </p>
                  <p
                    v-if="order.customerNote && order.saleNote"
                    class="dashed"
                  ></p>
                  <p v-if="order.saleNote" class="pre-line">
                    {{ order.saleNote }}
                  </p>
                </td> -->

                <td
                  :rowspan="contract.contractDetail.length"
                  v-if="j === 0 || contract.show ? true : false"
                  class="align-middle text-center"
                  style="white-space: nowrap"
                >
                  <!-- Đã giữ hàng / phân bổ xe — set khi → allocated, hoặc confirmBy legacy -->
                  <template
                    v-if="contract.confirmBy || contract.status === 'allocated'"
                  >
                    <b-badge
                      variant="success"
                      class="d-inline-flex align-items-center"
                    >
                      <i
                        style="color: #fff !important"
                        class="fas fa-check mr-1"
                      ></i>
                      <span>Đã phân bổ</span>
                    </b-badge>
                    <div v-if="contract.userConfirm" class="small mt-1">
                      {{ contract.userConfirm.fullName }}
                    </div>
                    <div v-if="contract.confirmDate" class="small text-muted">
                      {{ formatDate(contract.confirmDate) }}
                    </div>
                  </template>
                  <!-- Đã đặt cọc → cho duyệt giữ hàng -->
                  <b-button
                    v-else-if="
                      canQuickConfirm(contract) &&
                      checkPermissions(['CONTRACT_CONFIRM'])
                    "
                    size="sm"
                    variant="outline-primary"
                    @click="quickConfirmContract(contract)"
                  >
                    <i class="fas fa-warehouse mr-1"></i>Phân bổ
                  </b-button>
                  <!-- Chưa đặt cọc → cột phân bổ chưa có nghĩa (trạng thái HĐ đã hiện "Chờ cọc") -->
                  <span v-else class="text-muted">—</span>
                </td>

                <td
                  :rowspan="contract.contractDetail.length"
                  v-if="j === 0 || contract.show ? true : false"
                  class="align-middle"
                >
                  <div class="d-flex justify-content-center">
                    <b-dropdown size="sm" id="dropdown-left" no-caret right>
                      <template slot="button-content">
                        <i
                          style="font-size: 1rem; padding-right: 0px"
                          class="fa-solid fa-gear"
                        ></i>
                      </template>
                      <!-- <b-dropdown-item
                        @click="printOrder(order)"
                        v-if="checkPermissions(['ORDER_VIEW'])"
                        lazy
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="flaticon2-printer icon-color"
                          ></i>
                          &nbsp; In đơn hàng
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-show="showConvertToBill(order.status)"
                        @click="createBill(order)"
                        v-if="
                          checkPermissions(['BILL_INSERT']) &&
                          order.companyId === 3
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="flaticon2-add-1 icon-color"
                          ></i>
                          &nbsp; Tạo hóa đơn bán lẻ
                          <MerchantLabel :merchantId="orderItem.merchantId" />
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-show="showConvertToBill(order.status)"
                        @click="createWholeSaleInvoice(order)"
                        v-if="
                          checkPermissions(['BILL_INSERT']) &&
                          order.companyId === 3
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="flaticon2-add-1 icon-color"
                          ></i>
                          &nbsp; Tạo hóa đơn bán buôn
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="getOrderSelected('on-setting', order)"
                        v-if="checkPermissions(['ORDER_UPDATE'])"
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="fas fa-sync-alt icon-color"
                          ></i>
                          &nbsp; Đổi trạng thái
                        </span>
                      </b-dropdown-item> -->
                      <b-dropdown-item @click="editItem(contract)">
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="flaticon2-pen icon-color"
                          ></i>
                          &nbsp; Chỉnh sửa
                        </span>
                      </b-dropdown-item>
                      <!-- 2026-05-19: Gỡ xe / Hủy ghép — chỉ HĐ đang
                           'allocated' chưa có hóa đơn. Mở trang HĐ (nút "Gỡ
                           xe / Hủy ghép" + modal nằm ở Upsert.vue) để gom 1
                           luồng. KHÔNG trùng legacy "Hủy duyệt phiếu" (gated
                           !contract.status — chỉ HĐ luồng cũ). -->
                      <b-dropdown-item
                        @click="editItem(contract)"
                        v-if="
                          contract.status === 'allocated' &&
                          !contract.bill &&
                          checkPermissions(['CONTRACT_APPROVE'])
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i class="fas fa-unlink" style="color: #f59e0b"></i>
                          &nbsp; Gỡ xe / Hủy ghép
                        </span>
                      </b-dropdown-item>
                      <!-- 2026-05-14: "Tạo hóa đơn" chuyển lên ngay sau "Chỉnh
                           sửa" theo yêu cầu user — action chính của HĐ đã
                           duyệt + giữ hàng nên ưu tiên đặt trên. Trước đây
                           item này ở cuối dropdown. -->
                      <b-dropdown-item
                        @click="linktoCreateBill(contract.id)"
                        v-if="
                          (contract.status === 'allocated' ||
                            (contract.approveBy && contract.confirmBy)) &&
                          !contract.bill
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="flaticon2-add-1 icon-color"
                          ></i>
                          &nbsp; Tạo hóa đơn
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          showModalDownPayment(
                            contract.contractNumber,
                            contract.storeId,
                            contract.id,
                          )
                        "
                        v-if="contract.approveBy && !contract.bill"
                      >
                        <i
                          style="font-size: 1rem"
                          class="fas fa-hand-holding-usd"
                        ></i>
                        &nbsp;Tạo phiếu thu cọc
                      </b-dropdown-item>
                      <!-- Hủy HĐ (luồng mới — đặt cọc/refund được xử lý ở trang chi tiết).
                           Ẩn khi HĐ đã có hóa đơn / đã tạo hóa đơn / đã giao / hoàn tất / đã hủy. -->
                      <b-dropdown-item
                        v-if="
                          contract.status &&
                          !contract.bill &&
                          ![
                            'invoiced',
                            'delivered',
                            'completed',
                            'cancelled',
                          ].includes(contract.status)
                        "
                        @click="editItem(contract)"
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i class="fas fa-ban" style="color: #d33"></i>
                          &nbsp; Hủy hợp đồng…
                        </span>
                      </b-dropdown-item>
                      <!-- Legacy — chỉ HĐ chưa có status (luồng cũ) -->
                      <b-dropdown-item
                        @click="showModalCancel(contract.id)"
                        v-if="
                          !contract.status &&
                          contract.approveBy &&
                          !contract.confirmBy &&
                          checkPermissions(['CONTRACT_APPROVE'])
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i class="fas fa-ban"></i>
                          &nbsp; Hủy duyệt phiếu
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="showModalCancelConfirm(contract.id)"
                        v-if="
                          !contract.status &&
                          contract.approveBy &&
                          contract.confirmBy &&
                          !contract.bill &&
                          checkPermissions(['CONTRACT_CONFIRM'])
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i class="fas fa-ban"></i>
                          &nbsp; Hủy duyệt giữ hàng
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="showDeleteAlert(contract.id)"
                        v-if="
                          !contract.approveBy &&
                          !contract.confirmBy &&
                          !contract.bill &&
                          checkPermissions(['CONTRACT_DELETE'])
                        "
                      >
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem; color: #d33"
                            class="flaticon2-rubbish-bin-delete-button"
                          ></i>
                          &nbsp; Xóa
                        </span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </td>
              </tr>
            </template>
          </template>
          <tr v-show="!onLoadingList">
            <td
              :colspan="3"
              class="align-middle text-right icon-color font-weight-bolder"
            >
              Tổng
            </td>

            <td class="align-middle text-right icon-color font-weight-bolder">
              {{ sumQuantity }}
            </td>
            <!-- <td class="align-middle text-right icon-color font-weight-bolder">
              <p class="mb-0">
                <i
                  v-b-tooltip.hover
                  title="Phí vận chuyển"
                  class="fa fa-truck header-table-color"
                  style="font-size: inherit"
                ></i>
                {{ convertPrice(sumShipFee) }}
              </p>
              <p class="mb-0">
                <i
                  v-b-tooltip.hover
                  title="Phí ship báo khách"
                  class="fas fa-user header-table-color"
                  style="font-size: inherit"
                ></i>
                {{ convertPrice(sumCustomerShipFee) }}
              </p>
            </td> -->
            <!-- <td class="align-middle text-right icon-color font-weight-bolder">
              <p class="mb-0">
                <i
                  v-b-tooltip.hover
                  title="Tổng chuyển khoản"
                  class="fas fa-university header-table-color"
                  style="font-size: inherit"
                ></i>
                {{ convertPrice(sumTransferAmount) }}
              </p>
              <p class="mb-0">
                <i
                  v-b-tooltip.hover
                  title="Tổng đặt cọc"
                  class="fas fa-user header-table-color"
                  style="font-size: inherit"
                ></i>
                {{ convertPrice(sumDepositAmount) }}
              </p>
              <p class="mb-0" v-b-tooltip.hover title="Tổng thu">
                {{ convertPrice(sumTotalAmount) }}
              </p>
            </td> -->
            <td></td>
            <td></td>
            <td>
              <p class="mb-0 text-right">
                <i
                  v-b-tooltip.hover
                  title="Tổng tiền của hợp đồng"
                  class="fas fa-university header-table-color"
                  style="font-size: inherit"
                ></i>
                {{ convertPrice(sumTotalAmount) }}
              </p>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <vcl-table
        v-if="onLoadingList"
        :speed="5"
        :animate="true"
        :columns="10"
      ></vcl-table>
      <b-row>
        <b-col lg="3" md="3" sm="12">
          <p class="mt-3 text-dark" style="font-weight: 500">
            Tổng số:
            {{ convertPrice(mainList.total) }}
          </p>
        </b-col>
        <b-col lg="9" md="9" sm="12">
          <b-pagination-nav
            pills
            v-show="mainList.pages >= 2"
            :number-of-pages="mainList.pages"
            :link-gen="linkGen"
            align="right"
            v-model="currentPage"
            use-router
            @change="fetchMainData()"
          ></b-pagination-nav>
        </b-col>
      </b-row>
    </div>

    <template v-if="checkPermissions(['ORDER_UPDATE'])">
      <b-modal
        v-model="showEditNoteModal"
        hide-footer
        :title="'Sửa ghi chú cho đơn hàng #' + orderNoteModel.id"
      >
        <b-row class="mb-5">
          <b-col>
            <label class="labelInput" for="inputOriginalPrice"
              >Ghi chú bán hàng</label
            >
            <b-form-textarea
              v-model="orderNoteModel.customerNote"
              placeholder="Nhập ghi chú..."
              rows="5"
              max-rows="6"
            />
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <label class="labelInput">Ghi chú nội bộ</label>
            <b-form-textarea
              v-model="orderNoteModel.saleNote"
              placeholder="Nhập ghi chú..."
              rows="5"
              max-rows="6"
            />
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <label class="labelInput">Ghi chú bảo hành</label>
            <b-form-textarea
              v-model="orderNoteModel.warrantyNote"
              placeholder="Nhập ghi chú bảo hành..."
              rows="5"
              max-rows="6"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="updateNote"
              >Lưu</b-button
            >
            <b-button
              style="margin-left: 10px; font-weight: 600; width: 70px"
              variant="secondary"
              size="sm"
              @click="handleShowNoteModel"
              >Hủy</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
    </template>
    <template v-if="checkPermissions(['ORDER_UPDATE'])">
      <b-modal
        size="xl"
        hide-footer
        :title="titleOrderFromModal"
        id="md-edit-order"
      >
        <template>
          <UsertOrder
            :fromModal="true"
            :orderIdFromModal="orderIdFromModal"
            v-on:refresh-order="refreshOrder"
          />
        </template>
      </b-modal>
    </template>
    <template>
      <DownPaymentForm
        ref="popup-down-payment"
        v-on:fetchContract="fetchMainData"
      />
    </template>
    <template>
      <b-modal
        ref="file-modal"
        size="lg"
        hide-footer
        title="Chỉnh sửa tệp"
        id="file-modal"
      >
        <b-row>
          <b-col cols="12">
            <UploadFile :id="entityUploadId" :entity="'contracts'" />
          </b-col>
        </b-row>
      </b-modal>
    </template>
    <AllocateChassisModal
      ref="allocateChassisModalRef"
      :contractId="allocateContractId"
      @allocated="onAllocatedDone"
    />
  </div>
</template>

<style scoped>
.orderCode:hover {
  text-decoration: underline;
  cursor: pointer;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.sttClass {
  width: 20px;
}

/* .table th {
  padding: 0.6rem;
  } */

.table td {
  /* text-align: center !important;
    vertical-align: middle; */
  padding: 0.6rem;
}

.tdItemWidth {
  width: 350px;
}
.tdCenter {
  vertical-align: middle;
}
.icon-color {
  color: #464e5f;
}
.header-table-color {
  color: rgb(24, 28, 50);
}

.table-bordered-list th {
  border: 0.5px solid #d2d4d6 !important;
  background-color: #e0e0e0;
}

.table-bordered-list td {
  border: 0.5px solid #f3f3f3;
  /* border: 0.5px solid #fdfbfb; */
  /* border: 0.5px solid #d5d5d5; */
  border-bottom: 0.5px solid #adadad;
}

.select-style {
  border-radius: 0.28rem;
  box-shadow: none;
  border: 1px solid #ced4da;
}
.dashed {
  border: 1px dashed #464e5f;
  border-style: none none dashed;
  color: #fff;
  background-color: #fff;
}

.wrapword {
  white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
  white-space: -webkit-pre-wrap; /* Chrome & Safari */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: pre-wrap; /* CSS3 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  word-break: break-word;
  white-space: normal;
}

.pre-line {
  white-space: pre-line;
}

.badge-dark-blue {
  background-color: #1861ad;
}
</style>
<style lang="scss">
.order-list-table {
  .btn.btn-secondary.dropdown-toggle:after {
    padding: 0px 0px 0px 5px;
    color: #3699ff;
  }
}

// Cảnh báo "Thiếu mã tham chiếu" — chữ đỏ, ngang hàng Ngày tạo.
// Icon kế thừa màu đỏ (frontend-styling rule #1) — tránh Metronic global `i { color }` đè.
.ctr-missing-code-text {
  color: #f64e60;
  font-weight: 600;
  i {
    color: inherit !important;
  }
}

#md-edit-order {
  @media (min-width: 1200px) {
    .modal-dialog.modal-xl {
      max-width: 1200px;
    }
  }
  .modal-body {
    padding: 0px;
  }
}
</style>
<script>
import { VclTable } from 'vue-content-loading';
import ApiService from '@/core/services/api.service';
import _ from 'lodash';
import {
  formatDate,
  convertPrice,
  makeToastSuccess,
  makeToastFaile,
  checkGroupOrderStatus,
  calculateDiscountAmountV2,
} from '../../../utils/common';
import jQuery from 'jquery';
import * as ENUM from '../../../utils/enum';
import * as ENUM_NAME from '../../../utils/enum-name';
import {
  TIME_OUT,
  ORDER_CANCEL_STATUS,
  ORDER_STATUS,
} from '../../../utils/constants';
import { checkPermissions } from '../../../utils/saveDataToLocal';
import {
  CONTRACT_STATUS_LABEL,
  CONTRACT_STATUS_VARIANT,
} from '@/core/constants/contract';
import UsertOrder from '@/view/pages/orders/UpsertOrder.vue';
import { mapGetters } from 'vuex';
import { SET_ORDER_STATUS_SELECTED } from '@/core/services/store/modules/order/order-seleted-status.module.js';
import { EventBus } from '@/core/services/event-bus';
import MerchantLabel from '../../components/MerchantLabel.vue';
import Swal from 'sweetalert2';
import DownPaymentForm from '@/view/components/payments/DownPaymentForm.vue';
import UploadFile from '@/view/modules/upload/Upload';
import AllocateChassisModal from '@/view/components/contracts/AllocateChassisModal.vue';

export default {
  props: ['paramSearch'],
  components: {
    VclTable,
    UsertOrder,
    MerchantLabel,
    DownPaymentForm,
    UploadFile,
    AllocateChassisModal,
  },
  data() {
    return {
      ENUM,
      ENUM_NAME,
      ORDER_STATUS,
      // contractId hiện đang được Phân bổ chassis qua modal (set khi user click
      // "Phân bổ" trên row, dùng làm prop cho AllocateChassisModal).
      allocateContractId: null,
      mainList: {
        dataset: [],
        total: 0,
        pages: 1,
      },
      onLoadingList: false,
      currentPage: 1,
      sumShipFee: 0,
      sumCustomerShipFee: 0,
      sumTransferAmount: 0,
      sumDepositAmount: 0,
      sumTotalAmount: 0,
      sumQuantity: 0,
      checkAllOrders: false,
      optionCancelStatus: ORDER_CANCEL_STATUS,
      apiParams: null,
      showEditNoteModal: false,
      orderNoteModel: {
        id: null,
        customerNote: null,
        saleNote: null,
        warrantyNote: null,
      },
      hoverTable: {
        dataId: null,
      },
      inActiveEnter: false,
      orderIdFromModal: null,
      titleOrderFromModal: '',
      customerInfo: {
        customerName: null,
        customerPhone: null,
        customerId: null,
      },
      entityUploadId: null,
    };
  },
  created() {
    this.apiParams = this.paramSearch;
  },
  mounted() {
    this.fetchMainData();
    this.$root.$on('popup-create-order', this.popupCreateOrder);
    EventBus.$on('re-seletect-order', this.reSelectOrders);
  },
  beforeDestroy() {
    this.$root.$off('popup-create-order', this.popupCreateOrder);
  },
  watch: {
    paramSearch: function (params) {
      this.apiParams = params;
      this.fetchMainData();
    },
  },
  methods: {
    formatDate,
    convertPrice,
    checkPermissions,
    calculateDiscountAmountV2,
    contractStatusLabel(status) {
      return CONTRACT_STATUS_LABEL[status] || status;
    },
    contractStatusVariant(status) {
      return CONTRACT_STATUS_VARIANT[status] || 'secondary';
    },
    // HĐ có ≥1 phiếu báo có (TRANSFER) chưa nhập mã tham chiếu (code rỗng).
    // payments load từ findAll đã lọc deleted nên không cần check lại.
    hasMissingPaymentCode(contract) {
      const payments = (contract && contract.payments) || [];
      return payments.some(
        (p) =>
          p &&
          p.type === 'TRANSFER' &&
          (!p.code || String(p.code).trim() === ''),
      );
    },
    goToContractRequest(id) {
      if (!id) return;
      this.$router.push({
        name: 'edit-contract-request',
        params: { id },
      });
    },

    showModalDownPayment(contractNumber, storeId, contractId) {
      this.$refs['popup-down-payment'].showModal({
        entityId: contractId,
        contractNumber,
        selectedStoreId: storeId,
        contractId,
      });
    },

    showDeleteAlert: function (id) {
      Swal.fire({
        title: 'Xóa hợp đồng!',
        text: 'Bạn có chắc muốn xóa hợp đồng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      }).then((result) => {
        if (result.value) {
          this.deleteItem(id);
        }
      });
    },
    async deleteItem(id) {
      ApiService.delete(`/contract/${id}`)
        .then(({ data }) => {
          if (data.status) {
            makeToastSuccess('Xóa hợp đồng thành công');
            this.fetchMainData();
            return;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    showModalCancel: function (id) {
      Swal.fire({
        title: 'Hoàn duyệt hợp đồng!',
        text: 'Bạn có chắc muốn hoàn duyệt hợp đồng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.cancelItem(id);
        }
      });
    },
    cancelItem(id) {
      ApiService.post('/contract/cancel-approve', { id })
        .then(({ data }) => {
          if (data.status) {
            makeToastSuccess('Hoàn duyệt hợp đồng thành công');
            this.fetchMainData();
            return;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    showModalCancelConfirm: function (id) {
      Swal.fire({
        title: 'Hoàn duyệt giữ hàng!',
        text: 'Bạn có chắc muốn hoàn duyệt giữ hàng hợp đồng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.cancelConfirmItem(id);
        }
      });
    },
    cancelConfirmItem(id) {
      ApiService.post('/contract/cancel-confirm', { id })
        .then(({ data }) => {
          if (data.status) {
            makeToastSuccess('Hoàn duyệt hợp đồng thành công');
            this.fetchMainData();
            return;
          }
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.$nprogress.done();
        });
    },
    openFileModal(item) {
      this.entityUploadId = item.id;
      this.$refs['file-modal'].show();
    },
    showApproveAlert: function (id) {
      const { href } = this.$router.resolve({
        name: 'edit-contract',
        params: { id: id },
        query: { isApproved: true },
      });
      window.open(href, '_blank');
    },
    showConfirmAlert: function (id) {
      const { href } = this.$router.resolve({
        name: 'edit-contract',
        params: { id: id },
        query: { isConfirm: true },
      });
      window.open(href, '_blank');
    },
    // ===== Luồng duyệt mới (state machine) — quick action từ list =====
    isContractSignedOrBeyond(c) {
      return [
        'signed',
        'deposited',
        'allocated',
        'paid',
        'invoiced',
        'delivered',
        'completed',
      ].includes(c.status);
    },
    canQuickApprove(c) {
      // luồng mới: chỉ khi đang "Chờ ký"; legacy (chưa có status): khi chưa duyệt
      return c.status ? c.status === 'pendingSignature' : !c.approveBy;
    },
    canQuickConfirm(c) {
      // luồng mới: chỉ khi "Đã đặt cọc"; legacy: đã duyệt HĐ + chưa giữ hàng
      return c.status
        ? c.status === 'deposited'
        : !!c.approveBy && !c.confirmBy;
    },
    transitionContractFromList(id, toStatus) {
      ApiService.post(`contract/${id}/transition`, { toStatus })
        .then(() => {
          makeToastSuccess('Cập nhật trạng thái hợp đồng thành công');
          this.fetchMainData();
        })
        .catch((err) => {
          makeToastFaile(
            (err.response && err.response.data && err.response.data.message) ||
              'Cập nhật trạng thái thất bại',
          );
          if (this.$nprogress) this.$nprogress.done();
        });
    },
    quickApproveContract(c) {
      // Legacy (chưa có status) → mở trang chi tiết ở chế độ duyệt cũ.
      if (!c.status) {
        this.showApproveAlert(c.id);
        return;
      }
      Swal.fire({
        title: 'Duyệt hợp đồng',
        text: 'Xác nhận duyệt hợp đồng (chuyển sang trạng thái "Đã ký")?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699ff',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Duyệt',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.transitionContractFromList(c.id, 'signed');
        }
      });
    },
    quickConfirmContract(c) {
      if (!c.status) {
        this.showConfirmAlert(c.id);
        return;
      }
      // 2026-05-14: thay flow Swal-confirm-transition trực tiếp bằng modal
      // AllocateChassisModal. Modal hiển thị xe của HĐ + cho user gán số
      // khung-số máy ngay; nếu sau update đủ chassis cho mọi xe + HĐ đang
      // `deposited` thì BE auto-transition sang `allocated`. Đỡ phải vào
      // Upsert riêng để pick chassis từng dòng. Xem
      // `components/contracts/AllocateChassisModal.vue` + BE
      // `POST /contract/:id/allocate-chassis`.
      this.allocateContractId = c.id;
      this.$nextTick(() => {
        if (this.$refs.allocateChassisModalRef) {
          this.$refs.allocateChassisModalRef.show();
        }
      });
    },
    onAllocatedDone() {
      // Reload list sau khi modal Phân bổ thành công (BE đã auto-transition
      // nếu đủ chassis → status có thể đổi từ deposited → allocated).
      // - `fetchMainData` reload bảng HĐ ở chính component này.
      // - emit `refresh` để parent (pages/contracts/List.vue) reload stats cards
      //   (số đếm "Đã đặt cọc / Đã phân bổ xe / ..." cũng đổi).
      if (typeof this.fetchMainData === 'function') {
        this.fetchMainData();
      }
      this.$emit('refresh');
    },
    hoverRow: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      if (this.hoverTable.dataId !== dataId) {
        const rows = jQuery(`[data=${dataId}]`);
        rows.addClass('tr-rowspan-hover');
        this.hoverTable.dataId = dataId;
      }
    },
    outRow: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      const rows = jQuery(`[data=${dataId}]`);
      rows.removeClass('tr-rowspan-hover');
      this.hoverTable.dataId = null;
    },
    handleShowNoteModel(item) {
      this.showEditNoteModal = !this.showEditNoteModal;
      this.orderNoteModel = {
        id: item.id,
        customerNote: item.customerNote,
        saleNote: item.saleNote,
        warrantyNote: item.warrantyNote,
      };
    },
    showConvertToBill(status) {
      return checkGroupOrderStatus().validToBill(status);
    },
    createWholeSaleInvoice: async function (item) {
      this.$router.push({
        name: 'add-wholesale-invoice',
        query: { fromOrderId: item.id },
      });
    },
    createBill: function (item) {
      this.$router.push({
        name: 'add-bill',
        query: { fromOrderId: item.id },
      });
    },
    printOrder: function (item) {
      const routeData = this.$router.resolve({
        name: 'print-order',
        query: { id: item.id },
      });
      window.open(routeData.href, '_blank');
    },
    updateNote: function () {
      ApiService.put('orders/update-note', this.orderNoteModel)
        .then((response) => {
          if (response.data.status === 1) {
            this.showEditNoteModal = !this.showEditNoteModal;
            this.fetchMainData();
            makeToastSuccess(response.data.message);
          } else {
            makeToastFaile(response.data.message);
          }
        })
        .catch(({ response }) => {
          makeToastFaile(response.$error);
        });
    },
    fetchMainData: function () {
      this.onLoadingList = true;
      // get params
      const params = this.apiParams;

      this.currentPage = this.$route.query.page || 1;
      params.page = this.currentPage;
      this.$store.dispatch(SET_ORDER_STATUS_SELECTED, []);
      ApiService.query(
        'contract',
        { params },
        {
          timeout: TIME_OUT,
        },
      )
        .then((response) => {
          const data = response.data.data;

          this.mainList.pages = data.paginations.totalPages || 1;
          this.mainList.total = data.paginations.total;
          this.orders = [];
          this.sumQuantity = 0;
          this.sumShipFee = 0;
          this.sumCustomerShipFee = 0;
          this.sumTransferAmount = 0;
          this.sumDepositAmount = 0;
          this.sumTotalAmount = 0;
          const dataset = [];
          data.data.map((item) => {
            const contracts = {
              ...item,
              groupSize: item.contractDetail.length,
              show: item.contractDetail.length <= 0 ? true : false,
              selected: false,
            };
            //  tiền thừa cho khách
            contracts.changeMoney =
              item.totalAmountCustomerPay < 0
                ? item.totalAmountCustomerPay * -1
                : item.totalAmountCustomerPay;

            this.sumQuantity = contracts.contractDetail.reduce((acc, cur) => {
              return acc + cur.quantity;
            }, this.sumQuantity);

            contracts['totalPaid'] = contracts.payments.reduce(
              (sum, { amount }) => sum + Number(amount),
              0,
            );
            contracts['totalRemainingAmount'] = Math.max(
              contracts['totalAmountAfterDiscount'] - contracts['totalPaid'],
              0,
            );

            // caculate
            this.sumShipFee += contracts.shipFee;
            this.sumCustomerShipFee += contracts.customerShipFee;
            this.sumTransferAmount += contracts.transferAmount;
            this.sumDepositAmount += contracts.depositAmount;
            this.sumTotalAmount += +contracts.totalAmountAfterDiscount;
            dataset.push(contracts);
          });
          this.mainList.dataset = dataset;
          this.onLoadingList = false;
          this.$nprogress.done();
        })
        .catch((error) => {
          this.onLoadingList = false;
          this.$nprogress.done();
          if (error.response) {
            makeToastFaile(
              error.response.data ? error.response.data.message : 'Lỗi',
            );
          } else {
            makeToastFaile(error.message || 'Lỗi');
          }
        });
    },
    getOrderSelected: async function (prop, item) {
      switch (prop) {
        case 'all':
          this.mainList.dataset.map((order) => {
            order.selected = this.checkAllOrders;
            return order;
          });
          break;
        case 'one':
          if (this.checkAllOrders === true) {
            this.checkAllOrders = false;
          } else {
            const count = this.mainList.dataset.filter(
              (order) => order.selected,
            );
            if (count === 10) {
              this.checkAllOrders = true;
            }
          }
          break;
        case 'on-setting':
          {
            const index = this.mainList.dataset.findIndex(
              (order) => order.id === item.id,
            );

            if (index > -1) {
              this.mainList.dataset[index].selected = true;
            }
          }
          break;
      }
      const selectedOrders = this.mainList.dataset.filter(
        (order) => order.selected,
      );

      await this.$store.dispatch(SET_ORDER_STATUS_SELECTED, selectedOrders);

      if (prop === 'on-setting') {
        EventBus.$emit('popup-common-order');
      }
    },
    sumAmount(key) {
      const outItems = this.mainList.dataset;
      return _.reduce(
        outItems,
        (sum, item) => {
          return sum + parseFloat(item[key]);
        },
        0,
      );
    },
    linkGen: (pageNum) => {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    linkToBill: function (billNumber) {
      const { href } = this.$router.resolve({
        name: 'update-bill',
        query: { id: billNumber },
      });
      window.open(href, '_blank');
    },
    linktoCreateBill(contractId) {
      const { href } = this.$router.resolve({
        name: 'update-bill',
        query: { fromContractId: contractId },
      });
      window.open(href, '_blank');
    },
    editItem: function (item) {
      this.$router.push({
        name: 'edit-contract',
        params: { id: item.id },
      });
    },
    editUser: function (item) {
      // Click tên/SĐT KH → mở CHI TIẾT HĐ (đồng nhất link mã HĐ = editItem),
      // KHÔNG link sang trang KH (trước đây luôn về update-customer/khách lẻ).
      this.$router.push({
        name: 'edit-contract',
        params: { id: item.id },
      });
    },
    getStatusCancelName(id) {
      const cancelStt = this.optionCancelStatus.find((x) => x.value == id);
      if (cancelStt) return cancelStt.text;
      return 'Chưa có trạng thái lý do';
    },
    showCancelStatus(order) {
      return order.cancelStatus && [7, 8, 11].includes(Number(order.status));
    },
    bindClassNameStatus(order) {
      let className = '';
      switch (order.status) {
        case ENUM.ORDER_STATUS.NEW: {
          className = 'badge badge-warning text-white';
          break;
        }
        case ENUM.ORDER_STATUS.CONFIRMING: {
          className = 'badge badge-light';
          break;
        }
        case ENUM.ORDER_STATUS.CONFIRMED: {
          className = 'badge badge-primary text-white';
          break;
        }
        case ENUM.ORDER_STATUS.AGREE_DEPOSIT: {
          className = 'badge badge-dark-blue text-white';
          break;
        }
        case ENUM.ORDER_STATUS.KEEP_DEPOSIT: //IP14
        case ENUM.ORDER_STATUS.DELIVERY: {
          className = 'badge badge-warning';
          break;
        }
        case ENUM.ORDER_STATUS.TRACKING:
        case ENUM.ORDER_STATUS.PACKING: {
          className = 'badge badge-info';
          break;
        }
        case ENUM.ORDER_STATUS.SUCCESS: {
          className = 'badge badge-success';
          break;
        }
        case ENUM.ORDER_STATUS.UN_SUCCESS:
        case ENUM.ORDER_STATUS.SYSTEM_CANCEL:
        case ENUM.ORDER_STATUS.CR_CANCEL: {
          className = 'badge badge-dark';
          break;
        }
        case ENUM.ORDER_STATUS.REFUNDED:
        case ENUM.ORDER_STATUS.DEPOSIT: {
          className = 'badge badge-danger';
          break;
        }
        case ENUM.ORDER_STATUS.NO_CATCHED_PHONE: {
          className = 'badge badge-secondary';
          break;
        }
        case ENUM.ORDER_STATUS.PREPARED: {
          className = 'badge badge-danger text-dark';
          break;
        }
      }
      return className;
    },
    bindClassNamePayment(order) {
      let className = '';
      switch (order.partnerPaymentStatus) {
        case ENUM.PARTNER_PAYMENT.SUCCESS: {
          className = 'text-success';
          break;
        }
        case ENUM.PARTNER_PAYMENT.FAIL: {
          className = 'text-danger';
          break;
        }
        case ENUM.PARTNER_PAYMENT.AGREE_DEPOSIT: {
          className = 'text-primary';
          break;
        }
        case ENUM.PARTNER_PAYMENT.DEPOSIT: {
          className = 'text-warning';
          break;
        }
      }
      return className;
    },
    popupEditOrder(orderId) {
      this.orderIdFromModal = orderId;
      this.titleOrderFromModal = 'Chỉnh sửa đơn hàng';
      this.$bvModal.show('md-edit-order');
    },
    popupCreateOrder() {
      this.orderIdFromModal = null;
      this.titleOrderFromModal = 'Thêm mới đơn hàng';
      this.$bvModal.show('md-edit-order');
    },
    refreshOrder() {
      this.fetchMainData();
      this.$bvModal.hide('md-edit-order');
    },
    reSelectOrders(orders) {
      if (!orders) {
        return;
      }
      const orderIds = orders.map((item) => item.id);

      this.mainList.dataset.forEach((item) => {
        if (orderIds.includes(item.id)) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    },
  },
  computed: {
    ...mapGetters(['getOrderStatus']),
    sumQty() {
      let sum = 0;
      _.map(this.mainList.dataset, (item) => {
        const tmpSum = _.sumBy(item.billItems, 'quantity');
        sum += tmpSum;
      });
      return sum;
    },
  },
};
</script>
